module.exports = __webpack_public_path__ + "img/newsImg3-11.8c10c408.png";